import './index.css'

import cn from 'clsx'
import React, { useCallback, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { getLocationBeforeTransitions } from '@disco/state-management/selectors/routing'
import {
  makeGetShortlistById,
  shortlistHasActiveUploads,
} from '@disco/state-management/selectors/shortlists'

import { getShortlistBaseRoute } from 'utils/routing'

import DropZonePlaceholder from 'components/ui/drop-zone-placeholder'
import { NEW_SORTABLE_ITEM_KEY } from 'components/ui/sortable'

import ShortlistDropWrapper from 'containers/ShortlistDropWrapper'

import { useSelector } from 'hooks/use-redux'

import ShortlistActions from './actions'
import ShortlistItems from './items'

type Props = {
  shortlistId: string
  flash: boolean
  uploadFiles: (..._args: Array<any>) => any
}

const Shortlist = (props: Props): React.ReactNode => {
  const navigate = useNavigate()
  const containerRef = useRef()
  const shortlist = useSelector(state =>
    makeGetShortlistById()(state, {
      id: props.shortlistId,
    }),
  )
  const activeUploads = useSelector(state =>
    shortlistHasActiveUploads(state, {
      id: props.shortlistId,
    }),
  )
  const location = useSelector(getLocationBeforeTransitions)
  const { shortlistId, uploadFiles } = props
  const { id, isActive, playlist_id, sort_key } = shortlist
  const shortlistDropItem = {
    id: shortlist.items.length,
  }
  const [dropFilesActive, setDropFilesActive] = useState<boolean>(false)

  const navigateToFileImport = () => {
    const baseRoute = getShortlistBaseRoute(location)
    navigate(`${baseRoute}/shortlists/${shortlistId}/file-import`)
  }

  const handleOrderUpdate = useCallback((order: string[], item?: any) => {
    if (order) {
      setDropFilesActive(
        Boolean(item?.files) &&
          order[order.length - 1] === NEW_SORTABLE_ITEM_KEY,
      )
    }
  }, [])
  const shortlistClassName = cn('Shortlist', {
    flash: props.flash,
  })
  return (
    <ShortlistDropWrapper
      shortlistId={shortlist.id}
      item={shortlistDropItem}
      uploadFiles={uploadFiles}
    >
      <div
        className={shortlistClassName}
        id={`Shortlist_${shortlist.id}`}
        ref={containerRef}
      >
        <ShortlistActions shortlist={shortlist} activeUploads={activeUploads} />
        {isActive && (
          <div className="Shortlist_Playlist">
            <ShortlistItems
              key={`${id}-${sort_key}`}
              playlistId={playlist_id}
              shortlistId={id}
              onOrderUpdate={handleOrderUpdate}
              hidePreview={dropFilesActive}
            >
              <DropZonePlaceholder
                active={dropFilesActive}
                onClick={navigateToFileImport}
              />
            </ShortlistItems>
          </div>
        )}
      </div>
    </ShortlistDropWrapper>
  )
}

export default Shortlist
